<template>
	<li class="list-group-item px-0 py-3 lh-sm hstack gap-1">
		<div class="vstack">
			<div class="fw-bold link-dark">Contactar por correo</div>
			<small class="d-block fw-normal">{{ value }}</small>
		</div>
		<div class="hstack gap-4">
			<a :href="`mailto:${value}`" class="fw-bold link-dark" @click="select({ type: 'email' });"><i class="bi bi-envelope-at text-md"></i></a>
		</div>
	</li>
</template>

<script>
	export default {
		emits: ['select'],
		props: {
			value: String
		},
		setup(props, { emit }) {
			const select = (type) => emit('select', type);

			return { select };
		}
	}
</script>